import React from 'react';
import { Typography } from '@mui/material';
import appConfig from '../../config/appConfig';

const NoActiveSubscriptionAlert = ({ isFromPartner, partnerEmail }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      minHeight: '40px',
    }}
  >
    <Typography
      variant="body1"
      sx={{
        fontSize: '1rem',
        fontWeight: 'bold',
        textAlign: 'center',
      }}
    >
      {isFromPartner
        ? `No active subscription. Please reach out to ${partnerEmail}.`
        : `No active subscription. Please reach out to ${appConfig.brandEmail}.`}
    </Typography>
  </div>
);

export default NoActiveSubscriptionAlert;
